import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const postIdentifyEmailUser: DocumentNode = gql`
  mutation PostIdentifyEmailUser($externalId: String, $userAlias: IdentifyEmailUserAlias) {
    identifyEmailUser(input: { aliasesToIdentify: { externalId: $externalId, userAlias: $userAlias } }) {
      aliasesProcessed
      message
    }
  }
`

export default postIdentifyEmailUser
